module.exports = __webpack_public_path__ + "img/40_37_026_340.c38aff56.jpg";